import { cn } from './cn';

/** Texte riche saisi dans l'admin, déjà assaini par `sanitizeHtml` (voir utils/text.ts). */
export default function RichHtml({ html, className }: { html: string; className?: string }) {
  return <div className={cn('rich space-y-5 text-[1.0625rem] leading-relaxed', className)} dangerouslySetInnerHTML={{ __html: html }} />;
}
